import React from 'react';
import { Snackbar, Alert, AlertColor } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@/store';
import { removeNotification } from '@/store/slices/uiSlice';

const NotificationContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const { notifications } = useAppSelector((state) => state.ui);

  const handleClose = (notificationId: string) => {
    dispatch(removeNotification(notificationId));
  };

  return (
    <>
      {notifications.map((notification) => (
        <Snackbar
          key={notification.id}
          open={true}
          autoHideDuration={notification.autoHideDuration || 6000}
          onClose={() => handleClose(notification.id)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
          <Alert
            onClose={() => handleClose(notification.id)}
            severity={notification.severity as AlertColor}
            variant="filled"
            sx={{
              width: '100%',
              color: '#FFFFFF',
              ...(notification.severity === 'success' && { backgroundColor: '#228749' }),
              display: 'flex',
              alignItems: 'center',
              minHeight: '48px',
              maxWidth: '400px',
              fontSize: '14px',
              py: 0,
              '& .MuiAlert-message': {
                whiteSpace: 'normal',
                overflowWrap: 'anywhere',
              },
            }}
          >
            {notification.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
};

export default NotificationContainer;